__turbopack_context__.v({
  "container": "oNktvG_container",
  "contentContainer": "oNktvG_contentContainer",
  "infoSubTitle": "oNktvG_infoSubTitle",
  "infoTitle": "oNktvG_infoTitle",
  "informationItem": "oNktvG_informationItem",
});
